<template>
  <v-checkbox color="primary" persistent-hint :messages="$slots.message ? [''] : []">
    <template v-if="$slots.label" #label>
      <slot name="label" />
    </template>
    <template v-if="$slots.message" #message>
      <slot name="message" />
    </template>
  </v-checkbox>
</template>

<style scoped>
:deep(.v-input__control .v-checkbox-btn) {
  min-height: fit-content;
}
:deep(.v-input__details) {
  padding-top: 0;
  min-height: fit-content;
}
</style>